export default "__VITE_ASSET__C3XkIX5S__"